import { FC } from 'react';
import { ElementsButton } from '../../Button';
import clsx from 'clsx';

export type BlurContainerProps = {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  label?: string;
};

export const BlurContainer: FC<BlurContainerProps> = ({ children, className, label, onClick }) => {
  return (
    <div className={clsx('relative p-3', className)}>
      {!!label && (
        <ElementsButton
          className="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          label={label}
          onClick={onClick}
        />
      )}
      <div className="!pointer-events-none w-fit h-fit z-0 blur-md">{children}</div>
    </div>
  );
};
